import getMonolithHost from '../../utils/getMonolithHost';

export const ENTRY = 'signin';
export const BASE_PATH = '/signin';
export const PAGE_NAME = 'signin';
export const PAGE_TYPE = 'SignIn';
export const ANALYTICS_NAME = 'SignIn';
export const TITLE = 'Sign In | Zocdoc';
export const ROLLUP_BUCKET = 'Utility';

export const DEFAULT_PATIENT_REDIRECT = '/patient/medicalteam';
export const DEFAULT_PROVIDER_REDIRECT = '/provider/dash/performance';
export const DEFAULT_CSR_REDIRECT = 'https://pulse.zocdoc.com/csr/Main/Index';

export const SERVER_SIDE_TIMEOUT = 5000;

const apiHost = getMonolithHost();
const authPath = process.env.AUTH_PATH || `/api/rest/v1/userinfo`;
const authHost = process.env.AUTH_HOST || apiHost;

export const INTERNAL_JWT_GET_ENDPOINT = `${authHost}${authPath}`;
export const GET_USER_ENDPOINT = `${apiHost}/api/2/user`;

export const ZOCDOC_DIRECTORY_ID = '-1';

export const USER_TYPE = {
    PATIENT: 0,
    PROVIDER: 1,
};
